import Vue from 'vue';
import Component from 'vue-class-component';
import { ClientOrManager } from '@/api/profile';

@Component({
})
export default class PrivateOffice extends Vue {
    profile: ClientOrManager = this.$store.getters.profile
}